export default "/_next/static/chunks/fonts/pxiByp8kv8JHgFVrLEj6Z11lFc-K-a5fe02a198a858cdeb24a5ed26b2fffc.woff2";